"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.INPUT_TYPE_DUAL_CHOICE = exports.INPUT_TYPE_TICKET_ID = exports.INPUT_TYPE_SLIDER = exports.INPUT_TYPE_PICKER = exports.INPUT_TYPE_DATE = exports.INPUT_TYPE_MONEY = exports.INPUT_TYPE_PHONE = exports.INPUT_TYPE_PASSWORD = exports.INPUT_TYPE_NUMBER = exports.INPUT_TYPE_MULTILINE = exports.INPUT_TYPE_EMAIL = exports.INPUT_TYPE_TEXT = exports.themePaper = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const react_native_masked_text_1 = require("react-native-masked-text");
const picker_1 = require("@react-native-picker/picker");
const slider_1 = __importDefault(require("@react-native-community/slider"));
const react_i18next_1 = require("react-i18next");
const theme_1 = __importDefault(require("../../styles/theme"));
const constants_1 = require("../../constants/constants");
const icon_1 = __importStar(require("../icon/icon"));
const inputStyles_1 = __importDefault(require("./inputStyles"));
const pressableElement_1 = __importDefault(require("../pressables/pressableElement"));
const text_1 = __importStar(require("../text/text"));
const utils_1 = require("../../utils/utils");
const styles_1 = __importDefault(require("../../styles/styles"));
const colors_1 = __importDefault(require("../../styles/colors"));
exports.themePaper = {
    fonts: (0, react_native_paper_1.configureFonts)(constants_1.FONT_CONFIG),
};
exports.INPUT_TYPE_TEXT = 'text';
exports.INPUT_TYPE_EMAIL = 'email';
exports.INPUT_TYPE_MULTILINE = 'multiline';
exports.INPUT_TYPE_NUMBER = 'number';
exports.INPUT_TYPE_PASSWORD = 'password';
exports.INPUT_TYPE_PHONE = 'phone';
exports.INPUT_TYPE_MONEY = 'money';
exports.INPUT_TYPE_DATE = 'date';
exports.INPUT_TYPE_PICKER = 'picker';
exports.INPUT_TYPE_SLIDER = 'slider';
exports.INPUT_TYPE_TICKET_ID = 'ticketId';
exports.INPUT_TYPE_DUAL_CHOICE = 'dualChoice';
const Input = ({ type, isBVN, label = '', error = '', placeholder = '', setValue, value, choices, optional = false, required = false, minimumValue, maximumValue, symbol, step, setValueCustom, hasSetValueCustom = false, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    // password
    const [hidePass, setHidePass] = react_1.default.useState(true);
    // money
    const moneyValueLocal = value ? value.toString() : '';
    let image;
    let choiceM;
    if (choices) {
        const choiceMatched = choices.find((choice) => choice.value === value);
        if (choiceMatched && choiceMatched.image) {
            choiceM = {
                label: choiceMatched.label,
                value: choiceMatched.value,
                images: choiceMatched.image,
            };
            image = choiceM.images;
        }
    }
    const getPickerValue = (pickerValue) => {
        if (typeof pickerValue === 'boolean') {
            return pickerValue.toString();
        }
        if (pickerValue) {
            return pickerValue.toString();
        }
        return '';
    };
    return (react_1.default.createElement(react_native_1.View, { style: styles_1.default.minimumMarginBetweenElementsVertically },
        type === exports.INPUT_TYPE_MULTILINE && (react_1.default.createElement(react_native_paper_1.TextInput, { mode: "outlined", label: label, placeholder: placeholder, error: !!error, style: inputStyles_1.default.textBoxInput, keyboardType: "default", autoCorrect: false, autoCapitalize: "words", theme: exports.themePaper, onChangeText: (text) => {
                setValue(text);
            }, value: value ? value.toString() : '', multiline: true, numberOfLines: 3, underlineColorAndroid: "transparent", underlineColor: "transparent" })),
        type === exports.INPUT_TYPE_TEXT && (react_1.default.createElement(react_native_paper_1.TextInput, { mode: "outlined", label: label, placeholder: placeholder, error: !!error, keyboardType: "default", autoCorrect: false, autoCapitalize: "words", theme: exports.themePaper, onChangeText: (text) => {
                setValue(text);
            }, value: typeof value === 'number' || typeof value === 'boolean' ? value.toString() : value })),
        type === exports.INPUT_TYPE_EMAIL && (react_1.default.createElement(react_native_paper_1.TextInput, { mode: "outlined", label: label, placeholder: placeholder, error: !!error, keyboardType: "email-address", autoCorrect: true, autoCapitalize: "none", theme: exports.themePaper, onChangeText: (text) => {
                setValue(text);
            }, value: typeof value === 'number' || typeof value === 'boolean' ? value.toString() : value })),
        isBVN && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE }, t('input.bvn')),
            react_1.default.createElement(pressableElement_1.default, { onPress: react_native_1.Platform.OS === 'web' ? () => { } : () => react_native_1.Linking.openURL(`tel:${'*565*0%23'}`), eventName: "bvn_call_carrier" },
                react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, color: theme_1.default.colors.COLOR_BLUE }, t('input.dial'))))),
        type === exports.INPUT_TYPE_NUMBER && (react_1.default.createElement(react_native_paper_1.TextInput, { mode: "outlined", label: label, placeholder: placeholder, error: !!error, keyboardType: "numeric", theme: exports.themePaper, onChangeText: hasSetValueCustom
                ? setValueCustom
                : (text) => {
                    setValue(text);
                }, value: value ? value.toString() : '' })),
        type === exports.INPUT_TYPE_PASSWORD && (react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(react_native_paper_1.TextInput, { mode: "outlined", label: label, placeholder: placeholder, error: !!error, style: { zIndex: 0 }, secureTextEntry: hidePass, theme: exports.themePaper, autoCapitalize: "none", onChangeText: hasSetValueCustom
                    ? setValueCustom
                    : (text) => {
                        setValue(text);
                    }, value: value ? value.toString() : '' }),
            react_1.default.createElement(pressableElement_1.default, { onPress: () => setHidePass(!hidePass), style: inputStyles_1.default.iconPosition, eventName: "toggle_show_hide_user_password" },
                react_1.default.createElement(react_native_1.View, { style: [inputStyles_1.default.iconMargin, { zIndex: 1, shadowOpacity: 0 }] },
                    react_1.default.createElement(icon_1.default, { name: hidePass ? icon_1.CLOSED_EYES : icon_1.OPEN_EYES }))))),
        type === exports.INPUT_TYPE_MONEY && (react_1.default.createElement(react_native_masked_text_1.TextInputMask, { placeholder: placeholder, keyboardType: "numeric", type: "money", options: {
                unit: '\u20A6',
                precision: 0,
                delimiter: ',',
            }, customTextInput: react_native_paper_1.TextInput, customTextInputProps: {
                label,
                mode: 'outlined',
                value,
                onChangeText: (text) => {
                    setValue(text);
                },
            }, value: moneyValueLocal, onChangeText: (text) => {
                setValue(text.slice(1));
            }, placeholderTextColor: theme_1.default.colors.COLOR_GRAY_DARK })),
        type === exports.INPUT_TYPE_PHONE && (react_1.default.createElement(react_native_masked_text_1.TextInputMask, { placeholder: "+234", keyboardType: "numeric", onChange: (e) => setValue(e.nativeEvent.text), type: "custom", options: {
                mask: '+234 999 999 999 999 999',
            }, customTextInput: react_native_paper_1.TextInput, customTextInputProps: {
                label,
                mode: 'outlined',
                value,
                onChangeText: (text) => {
                    setValue(text);
                },
            }, value: typeof value === 'number' || typeof value === 'boolean' ? value.toString() : value, onChangeText: (text) => {
                setValue(text);
            }, maxLength: 25, placeholderTextColor: theme_1.default.colors.COLOR_GRAY_DARK })),
        type === exports.INPUT_TYPE_DATE && (react_1.default.createElement(react_native_masked_text_1.TextInputMask, { placeholder: "DD-MM-YYYY", type: "datetime", options: {
                format: 'DD-MM-YYYY',
            }, customTextInput: react_native_paper_1.TextInput, customTextInputProps: {
                label,
                mode: 'outlined',
                value,
                onChangeText: (text) => {
                    setValue(text);
                },
            }, value: typeof value === 'number' || typeof value === 'boolean' ? value.toString() : value, onChangeText: (text) => {
                setValue(text);
            } })),
        type === exports.INPUT_TYPE_TICKET_ID && (react_1.default.createElement(react_native_masked_text_1.TextInputMask, { placeholder: "xxxxxxx-xx", type: "custom", options: {
                format: '9999999-99',
                mask: '9999999-99',
            }, customTextInput: react_native_paper_1.TextInput, customTextInputProps: {
                label,
                mode: 'outlined',
                value,
                onChangeText: (text) => {
                    setValue(text);
                },
            }, value: typeof value === 'number' || typeof value === 'boolean' ? value.toString() : value, onChangeText: (text) => {
                setValue(text);
            } })),
        type === exports.INPUT_TYPE_PICKER && (react_1.default.createElement(react_native_paper_1.TextInput, { mode: "outlined", label: label, placeholder: placeholder, error: !!error, theme: exports.themePaper, value: getPickerValue(value), render: () => (react_1.default.createElement(react_native_1.View, { style: { flexDirection: 'row' } },
                image && (react_1.default.createElement(react_native_1.View, { style: {
                        flex: 1,
                        alignItems: 'center',
                        justifyContent: 'center',
                        paddingTop: 5,
                    } },
                    react_1.default.createElement(react_native_paper_1.Avatar.Image, { style: inputStyles_1.default.bankLogo, source: image, size: 35 }))),
                react_1.default.createElement(react_native_1.View, { style: { flex: 3, flexDirection: 'column', paddingRight: 3 } },
                    react_1.default.createElement(picker_1.Picker, { selectedValue: value, style: [
                            inputStyles_1.default.picker,
                            react_native_1.Platform.OS === 'web' ? { height: 55, fontSize: 14, paddingLeft: 5 } : {},
                        ], onValueChange: setValue }, choices.map((choice) => (react_1.default.createElement(picker_1.Picker.Item, { key: choice.label, label: choice.label, value: choice.value, style: react_native_1.Platform.OS === 'web' ? { fontSize: 14 } : {} }))))))) })),
        type === exports.INPUT_TYPE_SLIDER && (react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(react_native_1.View, null,
                react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE }, label)),
            react_1.default.createElement(react_native_1.View, null,
                react_1.default.createElement(react_native_1.View, { style: [inputStyles_1.default.valueContainer, styles_1.default.centerChildHorizontalVertical] },
                    react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_TITLE_SIZE_18, style: [{ lineHeight: 30, color: colors_1.default.COLOR_SECONDARY, fontWeight: 'bold' }] },
                        symbol,
                        (0, utils_1.formatNumber)(value))),
                react_1.default.createElement(react_native_1.View, { style: inputStyles_1.default.sliderContainer },
                    react_1.default.createElement(slider_1.default, { style: styles_1.default.flexOne, minimumValue: minimumValue, maximumValue: maximumValue, step: step, value: typeof value === 'number' ? value : 0, thumbTintColor: theme_1.default.colors.COLOR_BLUE, minimumTrackTintColor: theme_1.default.colors.COLOR_BLUE, maximumTrackTintColor: theme_1.default.colors.COLOR_GRAY_DARK, onValueChange: (newValue) => setValue(newValue) })),
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.justifySpaceBetween] },
                    react_1.default.createElement(react_native_1.View, { style: [] },
                        react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, style: [{ color: colors_1.default.COLOR_GRAY_DARK, lineHeight: 20, fontWeight: 'bold' }] },
                            symbol,
                            (0, utils_1.formatNumber)(minimumValue))),
                    react_1.default.createElement(react_native_1.View, { style: [] },
                        react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, style: [{ color: colors_1.default.COLOR_GRAY_DARK, lineHeight: 20, fontWeight: 'bold' }] },
                            symbol,
                            (0, utils_1.formatNumber)(maximumValue))))))),
        (!!error || optional || required) && (react_1.default.createElement(react_native_1.View, { style: inputStyles_1.default.info },
            react_1.default.createElement(text_1.default, { titleType: error ? text_1.TEXT_TYPE_ERROR : text_1.TEXT_TYPE_SUBTITLE_SIZE_10, color: error ? colors_1.default.COLOR_CRITICAL : colors_1.default.COLOR_GRAY_DARK },
                error,
                optional && 'Optional',
                required && 'Required')))));
};
Input.defaultProps = {
    isBVN: false,
    label: undefined,
    placeholder: undefined,
    setValue: undefined,
    value: undefined,
    choices: undefined,
    minimumValue: undefined,
    maximumValue: undefined,
    symbol: constants_1.NAIRA_SYMBOL,
    step: undefined,
    optional: undefined,
};
exports.default = Input;
